import { JsonapiEntity, attribute, entity } from 'jsonapi-transformers';

@entity({ type: 'reports' })
export class Report extends JsonapiEntity<Report> {
  @attribute() description: string;
  @attribute() report_type: string;
}
